/* eslint-disable max-len */
export default {
    video: {
        copy: 'Copy',
        copied: 'Copied',
        video_id: 'B7LaL0OL9MA',
        subject: 'Lemlock Video'
    }
};



// WEBPACK FOOTER //
// ./src/i18n/en/modals.js